/**
 * Compteur global des sauvegardes en cours (édition du nom du diagramme, du
 * tableau de tâches...). Comme chaque champ s'enregistre automatiquement dès
 * qu'on le quitte (voir DiagramPage/TaskTable), il n'y a jamais de brouillon
 * non enregistré au sens classique — seule une requête réseau en vol peut
 * être perdue si l'utilisateur ferme l'onglet ou change de page trop vite.
 * `guardNavigation`/le handler `beforeunload` s'appuient sur ce compteur pour
 * proposer d'attendre la fin de l'enregistrement avant de partir.
 */
let pendingCount = 0;

export function beginSave() {
  pendingCount += 1;
}

export function endSave() {
  pendingCount = Math.max(0, pendingCount - 1);
}

export function hasPendingSaves(): boolean {
  return pendingCount > 0;
}

/** À appeler avant toute navigation qui pourrait quitter la page en cours d'enregistrement. Renvoie true si la navigation peut continuer. */
export function confirmLeaveIfPending(message: string): boolean {
  if (!hasPendingSaves()) return true;
  return window.confirm(message);
}

/**
 * Diffusé UNIQUEMENT après qu'une réponse de succès soit revenue du serveur
 * (jamais de façon optimiste) — sert à afficher "Dernière sauvegarde : HH:MM"
 * dans DiagramPage. `endSave()` marque juste la fin d'une requête, réussie ou
 * non ; `markSaved()` est le signal distinct « le backend a confirmé ».
 */
export const SAVE_CONFIRMED_EVENT = 'gantt:save-confirmed';

export function markSaved() {
  window.dispatchEvent(new CustomEvent(SAVE_CONFIRMED_EVENT, { detail: { at: new Date().toISOString() } }));
}
